import { render, staticRenderFns } from "./bill_rank.vue?vue&type=template&id=6bf4070d&"
import script from "./bill_rank.vue?vue&type=script&lang=ts&"
export * from "./bill_rank.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports